export const SPREADSHEET_MIME_TO_EXTENSIONS: Record<string, string[]> = {
  'text/csv': ['.csv'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
    '.xlsx',
  ],
  'application/vnd.ms-excel.sheet.macroenabled.12': ['.xlsm'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.template': [
    '.xltx',
  ],
  'application/vnd.ms-excel.template.macroenabled.12': ['.xltm'],
}

export const SPREADSHEET_FILE_MIME_TYPES = Object.keys(
  SPREADSHEET_MIME_TO_EXTENSIONS,
)

export const SPREADSHEET_FILE_EXTENSIONS = Object.values(
  SPREADSHEET_MIME_TO_EXTENSIONS,
)
  .flat()
  .map((extension) => extension.slice(1))

export const TEXT_TYPE_FILE_EXTENSIONS: Array<string> = [
  'txt',
  'doc',
  'docx',
  'odt',
  'pdf',
  'rtf',
  'tex',
  'html',
  'htm',
  'md',
  'markdown',
  ...SPREADSHEET_FILE_EXTENSIONS,
  'xls',
]

export const ALLOWED_IMAGE_MIME_TYPES: Array<string> = [
  'image/gif',
  'image/jpeg',
  'image/png',
  'image/webp',
]

export const EXTENSION_TO_TYPE: Record<string, string> = {
  txt: 'document',
  doc: 'document',
  docx: 'document',
  odt: 'document',
  pdf: 'document',
  rtf: 'document',
  tex: 'document',
  xls: 'spreadsheet',
  ...Object.fromEntries(
    SPREADSHEET_FILE_EXTENSIONS.map((extension) => [extension, 'spreadsheet']),
  ),
  gif: 'image',
  jpg: 'image',
  jpeg: 'image',
  png: 'image',
  webp: 'image',
  mp4: 'video',
  mp3: 'audio',
  mpga: 'audio',
  mpg: 'audio',
  mpeg: 'audio',
  zip: 'archive',
  rar: 'archive',
  '7z': 'archive',
  tar: 'archive',
  gz: 'archive',
  bin: 'binary',
  exe: 'binary',
  dll: 'binary',
  so: 'binary',
  dylib: 'binary',
}

export const ALLOWED_MIME_TYPES: string[] = [
  'text/plain',
  'text/html',
  'text/markdown',
  'image/png',
  'image/jpeg',
  'image/webp',
  'image/gif',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/msword',
  'application/vnd.ms-excel',
  'application/pdf',
  'application/rtf',
  'application/vnd.oasis.opendocument.text',
  ...SPREADSHEET_FILE_MIME_TYPES,
]

export const ALLOW_MIME_TYPES_DROPZONE_ACCEPT: Record<string, string[]> =
  ALLOWED_MIME_TYPES.reduce((acc, type) => ({ ...acc, [type]: [] }), {})

export const ALLOWED_FILE_EXTENSIONS: Array<string> = [
  'txt',
  'doc',
  'docx',
  'odt',
  'pdf',
  'rtf',
  'tex',
  'html',
  'htm',
  'md',
  'markdown',
  ...SPREADSHEET_FILE_EXTENSIONS,
  'xls',
  'pptx',
]

export const FREE_TRIAL_FILE_SIZE_LIMIT: number = 50 * 1000 * 1000 // 50 MB

export const FILE_STALE_TIME = 1000 * 60 * 20 // 20 minutes
